import React from 'react';
import { CheckCircle2, Plus, Edit, Calendar, CalendarDays, ArrowUpDown, Flag, FileDown, Settings, CalendarClock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const HelpSection = ({ icon, title, children }) => (
  <div className="flex gap-3" data-testid={`help-section-${title.toLowerCase().replace(/\s+/g, '-')}`}>
    <div className="mt-0.5 shrink-0">{icon}</div>
    <div>
      <h4 className="font-semibold text-slate-900 mb-1">{title}</h4>
      <div className="text-slate-600 leading-relaxed">{children}</div>
    </div>
  </div>
);

const helpItems = [
  { icon: CheckCircle2, title: 'Mark a Task Complete', text: 'Click <strong>Edit</strong> next to a task. Change the status to <strong>Complete</strong> and save.' },
  { icon: Plus, title: 'Add a Custom Task', text: 'Click <strong>+ Add Task</strong> above the task list. Fill in Activity, Content, Goals, and Due Date.' },
  { icon: Edit, title: 'Edit a Task', text: 'Click <strong>Edit</strong> on any task to update hours logged, status, or due date.', note: 'Note: Only custom tasks allow editing all fields.' },
  { icon: Calendar, title: 'Change Your Start Date', text: 'Click <strong>Edit Start Date</strong>. All task due dates recalculate from this date.', note: 'Completion statuses are not changed automatically.' },
  { icon: CalendarDays, title: 'Switch Views', text: 'Use <strong>List</strong>, <strong>Week</strong>, or <strong>Month</strong> tabs to change how tasks are displayed.' },
  { icon: ArrowUpDown, title: 'Sort & Filter', text: 'Sort by <strong>Due Date</strong>, <strong>Name</strong>, or <strong>Status</strong>. Filter by <strong>All</strong>, <strong>Open</strong>, or <strong>Complete</strong>.' },
  { icon: Flag, title: 'Milestones', text: 'Milestones appear as highlighted rows in your task list showing key progress points.' },
  { icon: FileDown, title: 'Export to PDF', text: 'Click <strong>Download PDF</strong> in the progress section to save your plan.' },
  { icon: Settings, title: 'Security Question', text: "You'll be asked to set a security question on first login. This is used for password resets." },
  { icon: CalendarClock, title: 'Expiration Date', text: 'Your plan may have an expiration date set by an admin. Warnings appear at 30 and 7 days.' },
];

export const HelpDialog = ({ showHelp, setShowHelp }) => (
  <Dialog open={showHelp} onOpenChange={setShowHelp}>
    <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>Help Guide</DialogTitle>
      </DialogHeader>
      <div className="space-y-5 text-sm" style={{ fontFamily: 'Figtree, sans-serif' }}>
        {helpItems.map(({ icon: Icon, title, text, note }) => (
          <HelpSection key={title} icon={<Icon className="w-4 h-4 text-blue-600" />} title={title}>
            <p dangerouslySetInnerHTML={{ __html: text }} />
            {note && <p className="text-slate-500 mt-1">{note}</p>}
          </HelpSection>
        ))}
        <div className="pt-3 border-t border-slate-200 text-center text-xs text-slate-500">
          Need more help? Contact{' '}
          <a href="mailto:service@omnipear.com" className="text-blue-600 underline font-medium">service@omnipear.com</a>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
